import { render } from "./CentralDashboard.vue?vue&type=template&id=32da0aa4&ts=true"
import script from "./CentralDashboard.ts?vue&type=script&lang=ts&external"
export * from "./CentralDashboard.ts?vue&type=script&lang=ts&external"

import "./CentralDashboard.scss?vue&type=style&index=0&lang=css&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__